import Select from 'antd/lib/select';
import './index.css';

const { Option, OptGroup } = Select;

export default Select;
export { Option, OptGroup };
